import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import axiosConfig from '../../axiosConfig';
import { incrementCart, decrementCart, addToWishlist, removeFromWishlist } from '../../actions';
import QuickViewModal from '../../QuickViewModal';
import { scrollToTop } from '../../helper_funcitons';
import { Partners, FeaturedProducts, NewStores, ShopFeatures } from './HomeExtras';
import SkeletonLoader from '../Loaders/SkeletonLoader';

// Sub-components
import HomeSlider from './HomeSlider';
import CategoryGrid from './CategoryGrid';
import NewArrivals from './NewArrivals';

class Home extends React.Component {
    constructor(props) {
        super(props);
        window.MapComponent = this;
        let appState = localStorage.getItem('appState');
        if (appState) {
            appState = JSON.parse(localStorage.getItem('appState'));
        }

        this.state = {
            isLoggedIn: appState ? appState.isLoggedIn : false,
            app_site_url: process.env.REACT_APP_APP_SITE,
            app_site_storage_path: process.env.REACT_APP_APP_SITE_STORAGE_PATH,
            product_categories: [],
            hero_banners: [],
            new_arivals: [],
            our_partners: [],
            featured_products: [],
            featured_categories: [],
            merchant_shippings: [],
            storefronts: [],
            show_quickview_modal: false,
            product_id: "",
            loading: true,
        };

        this.addToCart = this.addToCart.bind(this);
        this.getHomePageContents = this.getHomePageContents.bind(this);
        this.toggleQuickViewModal = this.toggleQuickViewModal.bind(this);
    }

    addToCart(data) {
        let obj = {
            id: data,
            name: "oled TV" + data,
            price: (100 * data),
            quantity: 1,
        };
        this.props.incrementCart(obj);
    }

    resetJqueries() {
        let arr = ["/js/app-html.js"];
        window.popup_checkout_called = true;
        arr.forEach(el => {
            if (document.getElementById(el)) {
                document.getElementById(el).remove();
            }
            var script = document.createElement('script');
            script.id = el;
            script.src = el;
            script.defer = true;
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    }

    resetPartnersSlider() {
        if (document.getElementById("partner_slider")) {
            document.getElementById("partner_slider").remove();
        }
        var partner_slider_script = document.createElement('script');
        partner_slider_script.id = "partner_slider";
        partner_slider_script.text = `
            swipemode = true;
            maxXS = 480; maxSM = 768; maxMD = 992; maxLG = 1200;
            jQuery(document).ready(function() {
                if (jQuery('.js-brand-carousel').length) {
                    jQuery('.js-brand-carousel').each(function () {
                        var $this = jQuery(this);
                        if ($this.hasClass('slick-initialized')) return false;
                        var arrowsplace = $this.parent().find('.carousel-arrows').length ? $this.parent().find('.carousel-arrows') : $this,
                            slidesToShow_lg = 5, slidesToScroll_lg = 1,
                            slidesToShow_md = 4, slidesToScroll_md = 1;
                        $this.slick({
                            arrows: false, dots: false,
                            slidesToShow: slidesToShow_lg, slidesToScroll: slidesToScroll_lg,
                            appendArrows: arrowsplace, swipe: swipemode, infinite: true, draggable: false,
                            speed: 750, autoplay: true, autoplaySpeed: 3000,
                            cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                            responsive: [{
                                breakpoint: maxMD,
                                settings: { speed: 1000, slidesToShow: slidesToShow_md, slidesToScroll: slidesToScroll_md }
                            }, {
                                breakpoint: maxXS,
                                settings: { speed: 500, slidesToShow: 2, slidesToScroll: 1 }
                            }]
                        });
                    });
                }
            })
        `;
        document.getElementsByTagName('body')[0].appendChild(partner_slider_script);
    }

    async getHomePageContents() {
        await axiosConfig.get("/api/merchant-page-contents")
            .then(res => {
                if (res.data.success) {
                    this.setState({ ...res.data.data, loading: false }, () => {
                        this.resetJqueries();
                        this.resetPartnersSlider();
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                this.setState({ loading: false });
            });
    }

    async componentDidMount() {
        scrollToTop(0, 0);
        await this.getHomePageContents();
    }

    toggleQuickViewModal(id, quick_view_product = {}) {
        this.setState({
            product_id: id,
            quick_view_product
        }, () => {
            this.setState((prev) => ({
                show_quickview_modal: !prev.show_quickview_modal
            }));
        });
    }

    render() {
        const {
            hero_banners,
            featured_categories,
            new_arivals,
            app_site_storage_path,
            our_partners,
            featured_products,
            storefronts,
            merchant_shippings,
            show_quickview_modal,
            product_id,
            quick_view_product,
            loading
        } = this.state;

        return (
            <div className="page-content">
                {loading ? <div className="holder fullwidth fullboxed mt-0 full-nopad"><div className="container"><SkeletonLoader type="hero-banner" count={1} /></div></div> : (
                    <HomeSlider
                        hero_banners={hero_banners}
                        app_site_storage_path={app_site_storage_path}
                    />
                )}

                {loading ? <div className="holder holder-mt-small"><div className="container"><SkeletonLoader type="category-card" count={4} /></div></div> : (
                    <CategoryGrid
                        featured_categories={featured_categories}
                        app_site_storage_path={app_site_storage_path}
                    />
                )}

                {loading ? <div className="holder"><div className="container"><SkeletonLoader type="product-horizontal" count={3} /></div></div> : (
                    <NewArrivals
                        new_arivals={new_arivals}
                        toggleQuickViewModal={this.toggleQuickViewModal}
                    />
                )}

                {/* Optional/Commented sections moved to extras for cleaner Index.js */}
                {/* <Partners our_partners={our_partners} app_site_storage_path={app_site_storage_path} /> */}
                {/* <FeaturedProducts featured_products={featured_products} toggleQuickViewModal={this.toggleQuickViewModal} /> */}
                {/* <NewStores storefronts={storefronts} app_site_storage_path={app_site_storage_path} /> */}
                {/* <ShopFeatures merchant_shippings={merchant_shippings} /> */}

                {show_quickview_modal && (
                    <QuickViewModal
                        product_id={product_id}
                        toggleQuickViewModal={this.toggleQuickViewModal}
                        product_data={quick_view_product || {}}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    cart_reducer: state.cart_reducer,
    wishlist_reducer: state.wishlist_reducer,
});

const mapDispatchToProps = () => ({
    incrementCart, decrementCart, addToWishlist, removeFromWishlist,
});

export default connect(mapStateToProps, mapDispatchToProps())(Home);
